import * as React from 'react';

import { TComplainModalContext } from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ComplainModalContext = React.createContext<TComplainModalContext>(null as any);
